import { CURRENT_YEAR } from "../lib/currentYear";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-10" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-6 sm:flex-row sm:items-center lg:px-10">
        <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-600">
          © {CURRENT_YEAR} DMITRIY TRAPEZNIKOV — ALL RIGHTS RESERVED
        </span>
        <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-600">
          DESIGNED & BUILT WITH <span className="text-accent">REACT</span>
        </span>
      </div>
    </footer>
  );
}
